import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import Navbar from "./Navbar";
import ScrollToTop from "./ScrollToTop";
import MobileBottomNav from "./MobileAppChrome";
import "../../styles/layout/Navbar.css";

const Layout: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className={`app-shell ${isHomePage ? "app-shell--home" : "app-shell--inner"}`}>
      <ScrollToTop />
      <Navbar />
      <main className={isHomePage ? "app-main app-main--home" : "app-main app-main--page"}>
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
};

export default Layout;
